<template>
    <div>
        <app-modal 
            :show="show" 
            @close="close"
            width="md:w-1/2 lg:w-1/3"
        >
            <template slot="header">WHOIS Lookup</template>
            <template slot="body">
                <app-input
                    v-model="searchForm.q"
                    placeholder="Domain / ASN"
                    :error="searchForm.errors.get('q')"
                    @updated="searchForm.errors.clear('q')"
                    focus
                    required
                    @keyup.enter.native="check"
                />
                <div class="flex items-center justify-end mt-5">
                    <app-button 
                        class="btn-white"
                        @click="close"
                        :disable="checking"
                    >Cancel</app-button>
                    <app-button 
                        class="btn-blue ml-2"
                        @click="check"
                        :loading="checking"
                    >Check</app-button>
                </div>
            </template>
        </app-modal>
        <app-modal 
            :show.sync="showDomainInfoModal" 
            width="md:w-1/2 lg:w-1/3"
        >
            <template slot="header">WHOIS Lookup</template>
            <template slot="body"><div class="whitespace-pre-wrap">{{ domainInfo }}</div></template>
        </app-modal>
    </div>
</template>

<script>
import Form from '@/helpers/Form';
import Http from '@/helpers/Http';

export default {
    props: {
        show: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            showDomainInfoModal: false,
            domainInfo: null,
            checking: false,
            searchForm: new Form({
                q: null,
            })
        }
    },
    methods: {
        close() {
            this.$emit('update:show', false);
            this.$emit('close');
            this.searchForm.reset();
            this.searchForm.errors.clear();
        },
        check() {
            this.searchForm.errors.clear();
            this.checking = true;
            Http.post(`whois/check`, this.searchForm.payload())
                .then(({ data }) => {
                    this.checking = false;
                    this.showDomainInfoModal = true;
                    this.domainInfo = data.text;
                })
                .catch(({ response }) => {
                    this.checking = false;
                    this.searchForm.errors.record(response.data);
                })
        }
    }
}
</script>